<script>
import http from '../core/network/http.js'

function getReferenceInfos(reference, store) {
  return http.get(process.env.ERP_LOADER_URL + '/api/'+ store + '/references/'+ reference)
}

function getSupplier(supplier, store) {
    return http.get(process.env.ERP_LOADER_URL + '/api/'+ store + '/supplier/'+ supplier)
}

function getBlFromRef (reference) {
  return http.get(process.env.ERP_LOADER_URL + '/api/' + process.env.STORE + '/deliverydate/bl/' + reference)
}

export default {
    getReferenceInfos,
    getSupplier,
    getBlFromRef,
}
</script>


// WEBPACK FOOTER //
// src/api/erp_loader_server.vue